export default [
  {
    path: "/settings/payments-and-collections",
    name: "Payment",
    component: () => import("@/views/3pl/Settings/PaymentsAndCollections/index"),
  },
  // {
  //   path: "/new-estimate",
  //   name: "NewEstimate",
  //   component: () => import("@/views/3pl/Billings/Estimates/NewEstimate.vue")
  // },
];
 